import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const useStyles = makeStyles(() => ({
  animatedSection: {
    transition: 'opacity 0.8s cubic-bezier(0.4, 0, 0.2, 1), transform 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  // Fade in up animation
  fadeInUp: {
    opacity: 0,
    transform: 'translateY(60px)',
  },
  fadeInUpVisible: {
    opacity: 1,
    transform: 'translateY(0)',
  },
  // Fade in down animation
  fadeInDown: {
    opacity: 0,
    transform: 'translateY(-60px)',
  },
  fadeInDownVisible: {
    opacity: 1,
    transform: 'translateY(0)',
  },
  // Fade in left animation
  fadeInLeft: {
    opacity: 0,
    transform: 'translateX(-60px)',
  },
  fadeInLeftVisible: {
    opacity: 1,
    transform: 'translateX(0)',
  },
  // Fade in right animation
  fadeInRight: {
    opacity: 0,
    transform: 'translateX(60px)',
  },
  fadeInRightVisible: {
    opacity: 1,
    transform: 'translateX(0)',
  },
  // Scale in animation
  scaleIn: {
    opacity: 0,
    transform: 'scale(0.85)',
  },
  scaleInVisible: {
    opacity: 1,
    transform: 'scale(1)',
  },
  // Blur in animation
  blurIn: {
    opacity: 0,
    filter: 'blur(10px)',
    transform: 'translateY(30px)',
  },
  blurInVisible: {
    opacity: 1,
    filter: 'blur(0)',
    transform: 'translateY(0)',
  },
}));

const AnimatedSection = ({ 
  children, 
  animation = 'fadeInUp', 
  delay = 0,
  threshold = 0.1,
  className = '',
  style = {},
}) => {
  const classes = useStyles();
  const [ref, isVisible] = useScrollAnimation({ threshold });

  const getAnimationClass = () => {
    const baseClass = classes[animation] || classes.fadeInUp;
    const visibleClass = classes[`${animation}Visible`] || classes.fadeInUpVisible;
    return isVisible ? `${classes.animatedSection} ${visibleClass}` : `${classes.animatedSection} ${baseClass}`;
  };

  return (
    <div
      ref={ref}
      className={`${getAnimationClass()} ${className}`}
      style={{ 
        ...style,
        transitionDelay: `${delay}ms`,
      }}
    >
      {children}
    </div>
  );
};

export default AnimatedSection;
